export default "__VITE_ASSET__$Bcv14Re__"